import { Marketplace } from '../marketplace';
export class Additionalflat {
    constructor(
        public id?: number,
        public marketplaceNumber?: string,
        public validFrom?: any,
        public priceType?: string,
        public priceSanitary?: number,
        public priceCleaning?: number,
        public priceParking?: number,
        public priceAdministration?: number,
        public priceDebit?: number,
        public priceModification?: number,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public marketplace?: Marketplace,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat.model.ts